import dataModel from '../../models/DataModel.js';
import announcementsService from '../../services/announcementsService';
import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants.js';

export const announcements_root = {
  announcements: {},
};

export default class UnreadAnnouncementsCollection extends AOCollection {
  constructor(name) {
    super({
      name: name,
      collectionType: ReduxConstants.ANNOUNCEMENT,
    });
  }

  static build(name) {
    if (!name) {
      name = ReduxConstants.UNREAD_ANNOUNCEMENTS;
    }
    let collection = new UnreadAnnouncementsCollection(name);
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collectionData = collection.getDefaultData();
      collectionData = dataModel.collectionsDAO.setCollection(collection.getKey(), collectionData, collection.getCollectionType());
    }
    return collection;
  }

  handleOffLineFetch(options) {

    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection.teams);
    });
  }

  async fetchCurrent(shouldPaginate = true, options = {}, prefetchCallback) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        let serviceCall = announcementsService.getUnreadAnnouncements.bind(this, options);

        let newCollection = await this._fetchData(serviceCall, options, false, null, prefetchCallback);
        if (newCollection.offline) {
          return this.handleOffLineFetch(options);
        }

        return resolve(newCollection);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/UnreadAnnouncementsCollection.js